import { createDefaultRoles } from 'garaje/mirage/helpers/roles';
/**
 * Mirage Scenario with the absolute minimal amount of data required to get the site working
 *
 * NO FIXTURES ALLOWED!!!!
 *
 * @param {object} server Mirage Server
 */
export default function (server) {
  const company = server.create('company', 'withConfig', 'withLocation', 'withBillingCompany', 'withGlobalAdmin', {
    name: 'Cool Chip',
  });

  server.create('feature', {
    company_id: company.id,
    features: [],
  });

  createDefaultRoles(server);

  return { company };
}
